<template>
  <div>
  <div tabindex="0" ref="modal" class="modal-mask">  </div>

      <rare-modal-close-icon-large
        class="rareModalCloseIcon show-for-medium"
        @clicked="closeModal"
      />

    <rare-modal-close-icon-medium
      class="rareModalCloseIcon show-for-small-only"
      @clicked="closeModal"
    />

    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header text-center">
          <div class="heroImageCont"
               :class="{
             Ailsa: storyIDtoOpen === 'Ailsa',
             Hamze: storyIDtoOpen === 'Hamze',
             David: storyIDtoOpen === 'David',
             Leonie: storyIDtoOpen === 'Leonie',
             Francesca: storyIDtoOpen === 'Francesca',
             Roy: storyIDtoOpen === 'Roy',
             Sengova: storyIDtoOpen === 'Sengova',
             Tony: storyIDtoOpen === 'Tony',}">
            <div class="heroInnerWrapper">
              <div class="heroInner">

                <component
                  :is="headerContents"
                  :id="storyIDtoOpen"
                  :name="currentStory.storyName"
                  :position="currentStory.storyPosition"
                />

              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-6 cell page-contents-15-left">

                <img
                  class="quoteImg"
                  src="@/assets/img/icons/quote-large-trans.png"
                  alt="Contextual Recruitment story quote" />

              <div class='storyParagraph' v-html="currentStory.storyText"/>

              </div>
              <div class="hide-for-small-only medium-6 cell">
                &nbsp;
              </div>
        </div>
          </div>
        </div>
        <div class="modal-footer">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLarge';
import RareModalCloseIconMedium from 'rare-patternlab/icons/navigation/RareModalCloseIconMedium';

import RareStoriesHeaderContentsStory from './RareStoriesHeaderContentsStory';


export default {
  name: 'navigationModal',
  components: {
    'rare-apply-now-button': RareStandardButton,
    'rare-modal-close-icon-medium': RareModalCloseIconMedium,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
    'rare-stories-header-contents-story': RareStoriesHeaderContentsStory,
  },
  data() {
    return {
      headerContents: 'rare-stories-header-contents-story',
      currentStory: {},
      stories: {
        Ailsa: {
          storyName: 'Ailsa Harris',
          storyPosition: 'Deputy Director, Student Loans Company Sponsorship & Strategy and Rare alumnus',
          storyText: '<p>"I spent my whole university career being told I was ‘intimidating’. I’m not intimidating – I’m just Black and six feet tall. But it caught hold in my subconscious and I struggled to be assertive, because I didn’t want to be viewed as aggressive.</p><p>My sessions at Rare taught me that yes, I had a physical presence, but I could use that to command authority. Rare helped me see that I could be me in the assessment centre, and I could be heard. Not because people were ‘intimidated’ and had to listen to me, but because what I had to say deserved to be heard. Rare gave me the confidence and belief I needed to get onto the Fast Stream and flourish in my career."</p>',

        },
        Sengova: {
          storyName: 'Sengova Kailondo',
          storyPosition: 'Asset finance lawyer and Rare alumnus',
          storyText: '<p>“I arrived in England as an 11-year-old asylum seeker from war torn Sierra Leone and attended a low performing inner city school in special measures (which later closed down). Listening to advice from my parents and siblings, I focused in class and worked as hard as I could. Having escaped civil war, it was easy to stop myself getting distracted by kids standing on the tables. I was now in a land of immense opportunity – and I knew I had to make the most of it.</p><p>At university, my brother told me about Rare and I discovered the Articles programme. The one-on-one sessions with a former City lawyer were quite unlike anything I had ever done. It was effectively a boot camp for aspiring lawyers, challenging but formative and fun. The Articles programme did not aim to make the process easier for me as a Black individual from a disadvantaged background – it was about making me a better candidate and preparing me not just for an interview, but for my legal career. Thank God it all worked out and kudos to the team at Rare!"<p>',
        },
        Roy: {
          storyName: 'Roy Appiah',
          storyPosition: 'Litigation lawyer and Rare alumnus',
          storyText: '<p>"I took part in the Articles programme. I was put into a corporate environment with high calibre candidates. This was a bit strange coming from City University. But it prepared me for assessment days where everyone else was like that. It got rid of my inferiority complex and reminded me that I deserved to be there.</p><p>When you make job applications, you get the impression that you have to be the perfect candidate. I guess what Rare showed me is that being yourself is fine. It’s just about appreciating what it is about you that is actually rare and not being afraid to show it."</p>',
        },
        Tony: {
          storyName: 'Tony Upton',
          storyPosition: 'Future trainee lawyer and Rare contextual recruitment hire',
          storyText: '<p>I went to high school in North Essex. We had around 300 in our year group and 30 of us in a class so it wasn’t easy for even the best teacher, especially with kids who’d already mentally left school by the age of 14 and were only there because they had to be.</p><p>I did well at GCSE and transferred to the sixth form attached to our school. It had only been open for five years so they were still sorting out how everything would work - it wasn’t unheard of for a teacher to just stop turning up. My mum had done her O-levels then went straight into employment before leaving to look after me and my three sisters, while my dad left school at 15 and became a mechanic before working as a salesman. Our parents are incredibly supportive but they weren’t in a position to understand the process of applying for higher education.</p><p>My older sister had looked at Royal Holloway when she applied to university the year before. I visited the campus, really liked it, and applied to study law in the year the university started offering the course.</p> <p>At Royal Holloway, I finally found the learning environment I’d been looking for. On the one hand, the change of pace from A-level to degree was incredible - a big leap in self-discipline that was so enjoyable because I loved what I was learning about. On the other hand, it made me sad to realise that I could have done with that kind of kick back before I started my exams at high school.</p><p>During my time at sixth form and at university, I’d been working at Next on weekends and throughout the holidays to earn money. By my second year, I was applying to lots of firms for vacation schemes, but I wasn’t getting anything.</p><p>I got through the initial application round for the first time with Clyde & Co, and finally got a vacation scheme. I really enjoyed it and I’m so pleased that Clyde & Co offered me the financial support for my LPC and a training contract at the end of it. I think more law firms need to realise there are so many bright young people out there who haven’t been shown how to be a self-starter or given a reason to feel passionate about their subject at school. Without those things, you don’t necessarily understand why you’d apply yourself to a specific goal or profession.</p><p>For a long time, I felt anchored down by my A-level results because they didn’t reflect what I was capable of. I think employers need to look at the context of each person - there are so many factors that need to be assessed if you’re really looking for potential.</p>',
        },
        David: {
          storyName: 'David Odejayi',
          storyPosition: 'Litigation lawyer and Rare alumnus, now in the Enforcement Division at the Financial Reporting Council',
          storyText: '<p>"I joined Rare after hearing about them from a friend. I applied for the Articles programme, where I got the opportunity to visit Magic Circle law firms and speak with lawyers of all kinds of experience and background. I was inspired by this experience and it motivated me to research the career path of a commercial solicitor.</p> <p>The most helpful and most difficult part of the programme was the one-on-one sessions with Elham Saudi, a former lawyer from Slaughter and May. These sessions had a rigour and intensity I had never experienced and I quickly noticed my performance improve. You had to develop an ability to process information and give counter-arguments quickly as everything you said would be challenged.</p> <p>Rare has been an important source of support. The value of Rare comes not just through their ability to connect you with important people in the legal profession, but also through their efforts to bring out the best of your ability through regular one-on-one coaching and group sessions.</p><p>Rare has left me feeling much more capable than I was before I started the programme. I don’t just feel as though I am better at passing application processes; I feel as though I have honed the critical and analytical skills needed for success generally."</p>',
        },
        Hamze: {
          storyName: 'Hamze Ali',
          storyPosition: 'Associate Consultant and Rare alumnus',
          storyText: '<p>"Rare was pivotal in helping me achieve my offer from my dream company, Bain & Company. Rare helped me to develop the confidence it takes to push your boundaries and gave me the resources required to succeed in the consulting application process.</p><p>I come from a background and community where jobs such as consulting are alien, and it requires you to spend a few minutes to explain the role to individuals, whether that is family or local friends. My family is originally from Somalia and my parents supported me so much and made many sacrifices to get me into UCL to study Chemical Engineering. I quickly found out that I enjoyed the degree learning but wanted to go down a different career path and this is where Rare altered the course of my life.</p><p>I came across Rare\'s \'Consulting Programme\' and this enabled me to attend sessions at different firms, benefit from 1:1 mock case interview sessions with experts and to build a network of like-minded peers to prep with. These peers also became great friends that I keep in contact with until today.</p><p>My first year of applying was unsuccessful despite having interviews at my dream firm, Bain & Company. However, Rare pushed me to not give up on my dreams and I reapplied in the following year. I gave it my all and Rare was fully behind me, which really helped develop my confidence despite previously facing rejections.</p><p>One comment I got from a Rare instructor before my Bain final round was the following - “You are almost there. Don’t let up on the hard work. It is now time to give 200%.”. This shows how committed the team really are to your success and I am forever grateful and a huge advocate!"</p>',
        },
      },
    };
  },
  props: {
    storyIDtoOpen: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeStoriesModal');
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  mounted() {
    this.$refs.modal.focus();
  },
  created() {
    this.currentStory = this.stories[this.storyIDtoOpen];
    document.addEventListener('keyup', this.watchForEsc);
  },
  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    display: table;
    transition: opacity .3s ease;
    background-color: rgba(255,255,255, 1);
    overflow: hidden;
  }

  .modal-wrapper {
    vertical-align: middle;
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9991;
    overflow-y: scroll;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 0;
    background-color: transparent;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    opacity: 1;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 0 0 90px 0;
  }

  .modal-default-button {
    float: right;
  }

  .heroImageCont {
    background-size: cover;
    position: relative;
    width: 100%;
  }

  .heroInnerWrapper {
    position: absolute;
    z-index: 0;
    top:0;
    left:0;
    bottom: 0;
    right: 0;
  }

  .heroInner {
    height: 100%;
  }

  /* NAVIGATION TEXT STYLES FOR BOTH SIZES */


  @media only screen and (max-width: 640px)  {

    .page-contents-15-left {
      padding-left: 7% !important;
      padding-right: 7% !important;
    }

    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 22px;
      z-index: 9995;
    }

    .heroImageCont {
      background-position: 80% 0% !important;
    }

    .heroImageCont:before{
      content: "";
      display: block;
      padding-top: 100%;/* initial ratio of 1:1*/
    }

    .story {
      color: #485158;
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: 2px;
      text-align: left;
      text-transform: uppercase;
    }

    .quoteImg {
      height: 40px;
      margin: 48px 0 20px 0;
    }

  }

  @media only screen and (min-width: 641px)  {
    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 124px;
      top: 96px;
      z-index: 9995;
    }

    .heroImageCont:before{
      content: "";
      display: block;
      padding-top: 50%; /* initial ratio of 1:2*/
    }

    .story {
      color: #485158;
      font-size: 18px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.78;
      letter-spacing: 2px;
      text-align: left;
      text-transform: uppercase;
    }

    .quoteImg {
      height: 48px;
      margin: 96px 0 20px 0;
    }

  }

  .Ailsa {
    background-image: url("../../../assets/img/backgrounds/stories/Ailsa.jpg");
  }

  .Hamze {
    background-image: url("../../../assets/img/backgrounds/stories/Hamze.jpg");
  }
  .David {
    background-image: url("../../../assets/img/backgrounds/stories/David.jpg");
  }
  .Leonie {
    background-image: url("../../../assets/img/backgrounds/stories/Leonie.jpg");
  }
  .Francesca {
    background-image: url("../../../assets/img/backgrounds/stories/Nasteho.jpg");
  }
  .Tony {
    background-image: url("../../../assets/img/backgrounds/stories/Tony.jpg");
  }
  .Roy {
    background-image: url("../../../assets/img/backgrounds/stories/Roy.jpg");
  }
  .Sengova {
    background-image: url("../../../assets/img/backgrounds/stories/Sengova.jpg");
  }

</style>

<style>

@media only screen and (max-width: 640px)  {

  .storyParagraph {
  color: #485158;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.52;
  }


}

@media only screen and (min-width: 641px)  {

  .storyParagraph {
    color: #485158;
    font-size: 21px;
    font-weight: 400;
    line-height: 1.52;
  }

}


</style>



// WEBPACK FOOTER //
// src/pages/stories/components/RareStoriesStoryModal.vue